import { log } from "../../utils";
import { ChatServerAsyncActionType } from "../../utils/useChatServerDispatch";

export default function sendBargeIn(agentName: string): ChatServerAsyncActionType {
    return chatServer => () => {
        chatServer.bargeIn(agentName, (err?: Error) => {
            if (err) {
                log(err);
            }
        });
    };
}